module.exports = __webpack_public_path__ + "v294910/img/ai-avatar-day.4d4b48b4.png";